var CompositeDisposable, Emitter, ItemPathQuery, _, ref, util;

ref = require('event-kit'), Emitter = ref.Emitter, CompositeDisposable = ref.CompositeDisposable;

util = require('./util');

_ = require('underscore-plus');

module.exports = ItemPathQuery = (function() {
  ItemPathQuery.prototype.outline = null;

  ItemPathQuery.prototype.outlineSubscription = null;

  ItemPathQuery.prototype.outlineDestroyedSubscription = null;

  ItemPathQuery.prototype.debouncedRun = null;

  function ItemPathQuery(outline1, itemPath1) {
    this.outline = outline1;
    this.itemPath = itemPath1;
    this.emitter = new Emitter();
    this.debouncedRun = this.run.bind(this);
    this.outlineDestroyedSubscription = this.outline.onDidDestroy((function(_this) {
      return function() {
        return _this.destroy();
      };
    })(this));
    this.queryFunction = function(outline, contextItem, itemPath, options) {
      return outline.evaluateItemPath(itemPath, contextItem, options);
    };
  }

  ItemPathQuery.prototype.destroy = function() {
    if (!this.destroyed) {
      this.stop();
      this.outlineDestroyedSubscription.dispose();
      this.emitter.emit('did-destroy');
      this.outline = null;
      return this.destroyed = true;
    }
  };


  /*
  Section: Events
   */

  ItemPathQuery.prototype.onDidChange = function(callback) {
    return this.emitter.on('did-change', callback);
  };

  ItemPathQuery.prototype.onDidDestroy = function(callback) {
    return this.emitter.on('did-destroy', callback);
  };


  /*
  Section: Configuring Queries
   */

  ItemPathQuery.prototype.contextItem = null;

  Object.defineProperty(ItemPathQuery.prototype, 'contextItem', {
    get: function() {
      return this._contextItem;
    },
    set: function(_contextItem) {
      this._contextItem = _contextItem;
      return this.scheduleRun();
    }
  });

  ItemPathQuery.prototype.itemPath = null;

  Object.defineProperty(ItemPathQuery.prototype, 'itemPath', {
    get: function() {
      return this._itemPath;
    },
    set: function(_itemPath) {
      this._itemPath = _itemPath;
      return this.scheduleRun();
    }
  });

  ItemPathQuery.prototype.options = null;

  Object.defineProperty(ItemPathQuery.prototype, 'options', {
    get: function() {
      return this._options;
    },
    set: function(_options) {
      var ref1;
      this._options = _options;
      if ((ref1 = this._options) != null ? ref1.debounce : void 0) {
        this.debouncedRun = _.debounce(this.run.bind(this), this._options.debounce);
      } else {
        this.debouncedRun = this.run.bind(this);
      }
      return this.scheduleRun();
    }
  });

  ItemPathQuery.prototype.queryFunction = null;

  Object.defineProperty(ItemPathQuery.prototype, 'queryFunction', {
    get: function() {
      return this._queryFunction;
    },
    set: function(_queryFunction) {
      this._queryFunction = _queryFunction;
      return this.scheduleRun();
    }
  });


  /*
  Section: Running Queries
   */

  ItemPathQuery.prototype.started = false;

  ItemPathQuery.prototype.start = function() {
    if (this.started) {
      return;
    }
    this.started = true;
    this.outlineSubscription = this.outline.onDidEndChanges((function(_this) {
      return function(changes) {
        if (changes.length > 0) {
          return _this.scheduleRun();
        }
      };
    })(this));
    return this.run();
  };

  ItemPathQuery.prototype.stop = function() {
    if (!this.started) {
      return;
    }
    this.started = false;
    return this.outlineSubscription.dispose();
  };

  ItemPathQuery.prototype.scheduleRun = function() {
    if (this.started) {
      return this.debouncedRun();
    }
  };

  ItemPathQuery.prototype.run = function() {
    var nextResults;
    if (this.started) {
      nextResults = this.queryFunction(this.outline, this.contextItem, this.itemPath, this.options);
      if (!util.shallowArrayEqual(this.results, nextResults)) {
        this.results = nextResults;
        return this.emitter.emit('did-change', this.results);
      }
    }
  };


  /*
  Section: Getting Query Results
   */

  ItemPathQuery.prototype.results = [];

  return ItemPathQuery;

})();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/item-path-query.js
 ** module id = 210
 ** module chunks = 0
 **/